<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">search</i>
                        </div>
                        <h4 class="card-title ">Filtros</h4>
                    </div>
                    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" novalidate="novalidate" autocomplete="off">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.branche_id != null}">
                                        <label for="branche_id" class="bmd-label-floating">Loja</label>
                                        <model-list-select
                                                class="form-control"
                                                :list="branches"
                                                option-value="id"
                                                option-text="name"
                                                v-model="form.branche_id">
                                        </model-list-select>
                                        <label v-if="validation.branche_id != null" id="branch_id-error" class="error" for="branche_id">{{ validation.branch_id }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.date_at != null}">
                                        <label for="interval" class="bmd-label-floating">Intervalo</label>
                                        <date-picker
                                            range
                                            v-model="form.date_at"
                                            lang="pt-br"
                                            format="DD/MM/YYYY"
                                            placeholder="Escolha uma data"
                                            :not-after="form.end_at"
                                            >
                                        </date-picker>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.type_profile_id != null}">
                                        <label for="type_profiles" class="bmd-label-floating">Tipos de Perfil</label>
                                        <multi-select
                                                v-model="form.type_profile_id"
                                                placeholder="Selecione os Tipos de Perfis"
                                                label="name"
                                                track-by="name"
                                                value="id"
                                                :options="type_profiles"
                                                :multiple="true"
                                                :clear-on-select="false"
                                                :preserve-search="true">
                                        </multi-select>
                                        <label v-if="validation.type_profile_id != null" id="type_profile_id-error" class="error" for="type_profile_id">{{ validation.type_profile_id }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="team_id" class="bmd-label-floating">Equipe</label>
                                        <model-list-select
                                                class="form-control"
                                                :list="teams"
                                                option-value="id"
                                                option-text="name"
                                                v-model="form.team_id">
                                        </model-list-select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="team_id" class="bmd-label-floating">Vendedor</label>
                                        <model-list-select
                                                class="form-control"
                                                :list="responsibles"
                                                option-value="id"
                                                option-text="name"
                                                v-model="form.responsible_id">
                                        </model-list-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="reset" class="btn btn-fill btn-outline-danger">Limpar</button>
                            <button type="submit" class="btn btn-fill btn-rose">Gerar</button>
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import TypeProfiles from '@/services/modules/typeprofiles.service';
    import Utils from '@/services/utils.service';

    // 0
    export default {
        computed: {
            administrators: {
                get() {
                    return this.$store.state.administrators.itens;
                }
            },
            typesCommissions: {
                get() {
                    return this.$store.state.commissions.typeOfCommissions
                }
            },
            branches() {
                return this.$store.state.defaults.branches;
            },
            teams: {
                get() {
                    return this.$store.state.teams.itens;
                }
            },
            responsibles: {
                set(_items) {
                    this.$store.commit("users/setList", _items);
                },
                get() {
                    return this.$store.state.users.itens;
                }
            }
        },
        data() {
            return {
                 validation: {
                    date_at: null,
                     responsible_id: null,
                     team_id: null,
                     administrator_id : null,
                     branche_id: null,
                     type_profile_id: null,

                },
                type_profiles: [],
                form: {
                    responsible_id: null,
                    team_id: null,
                    administrator_id : null,
                    branche_id: null,
                    type_profile_id: [],
                    date_at: [Vue.moment().subtract(30, "days"), Vue.moment()],
                    end_at: Vue.moment().add(40, 'days'),
                },
                referenceDates: [
                    { id : 'sale_date', name : 'Data da Venda'},
                    { id : 'due_date' , name : 'Data de Vencimento'},
                    { id : 'payday'   , name : 'Data de Pagamento'},
                ],
            };
        },
        methods: {
            async getData() {
                 var self = this;
                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('commissions/typesOfcommissions');
                response.then(function () {
                    self.$root.$emit("onLoading");
                    self.getDataTeams();
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                    self.getDataTeams();
                });
            },
            onReset() {
                this.form = {
                    responsible_id: null,
                    team_id: null,
                    administrator_id : null,
                    branche_id: null,
                    date_at: [Vue.moment().subtract(30, "days"), Vue.moment()],
                    end_at: Vue.moment().add(40, 'days'),
                    type_profile_id: [],
                };
            },
            onSubmit() {
                var self = this;
                var valid = true;

                self.validation = {
                    date_at: null,
                    responsible_id: null,
                    team_id: null,
                    administrator_id : null,
                    branche_id: null,
                    type_profile_id: null,
                };

                if (!self.form.date_at[0] || !self.form.date_at[1]) {
                    valid = false;
                    self.validation.date_at = 'Favor informar o intervalo desejado!';
                }


                if (valid) {
                    var serialize = JSON.stringify(self.form);
                    window.open("print-media-conversion?form=" + serialize, '_blank');
                }
            },
            async getDataTeams() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('teams/all');

                response.then(function () {
                    self.$root.$emit("onLoading");
                    self.getUsers();
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                    self.getUsers();
                });
            },
            async getUsers() {
                var self = this;

                self.$root.$emit('onLoading');

                const response = self.$store.dispatch('users/all');

                response.then(function (x) {
                    self.responsibles = x;
                    self.$root.$emit('onLoading');
                    self.getDataProfiles();
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },
            async getDataProfiles() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = TypeProfiles.all();

                response.then(function (_profiles) {
                    self.type_profiles = _profiles.filter(profile => profile.id !== 1);
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
        },
        created() {
            var self = this;
            self.getData();
        }
    }
</script>
